import React, {useContext, useEffect, useState} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import EmojiLoading from "../../containers/emojiLoading/emojiLoading";

import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const [viewCount, setViewCount] = useState(0);
  const {isDark} = useContext(StyleContext);
  useEffect(() => {
    const getViewCount = () => {
      fetch("https://api.naven.io/view-count", {
        method: 'POST',
        mode: "cors"
      })
      .then(result => {
        if (result.ok) {
          return result.json();
        }
        throw result;
      })
      .then(response => {
        console.log(response)
          setViewCount(response['view-count'])
      })
        .catch(function (error) {
          console.error(
            `${error} (because of this error, nothing is shown in place of Projects section. Also check if Projects section has been configured)`
          );
          setViewCount(0);
        });
    };
    getViewCount();
  }, [])

  if (!greeting.displayGreeting) {
    return null;
  }

  

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {greeting.resumeLink && (
                  <Button
                    text="See my resume"
                    newTab={true}
                    href={greeting.resumeLink}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              ></img>
            )}
            <div className="greeting-view-count">
            View Count (Powered by AWS):  {viewCount ? viewCount : <EmojiLoading />}
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
